/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import "./navbar.css";
import { Route } from "react-router-dom";
import { Header, Icon, Button } from "semantic-ui-react";
export default (props) => {
  return (
    <div>
      <Header
        as="h2"
        style={{
          borderBottom: "2px solid #ff4901",
          backgroundImage: `url(${require("../../images/Speedline.png")})`,
          height: "100px",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Icon name="hand scissors outline" />

        <Header.Content>
          <Route
            render={({ history }) => (
              <Button
                className="Logo-button"
                onClick={() => {
                 
                  console.log(props.page);
                  if (props.page === 1 && (window.location.pathname !== '/confirm')) {
                    console.log("You are about to exit!!");
                    alert('You will need to start over if you exist now!')
                  } else {
                    history.push("/");
                    props.setPage(0);
                  }
                }}
              >
                Barbershop Booking
              </Button>
            )}
          />
        </Header.Content>
      </Header>
    </div>
  );
};
